<template>
    <a class="calendar-item"
        :class="buildClasses"
        :href="buildHref"
        :title="itemTitle(item, timezone)"
    >
        <slot></slot>
    </a>
</template>

<script>
import { isAppointment } from '@/utils/Filter';
/** CalendarItem is now just an empty container that sets classes and provides css

REMOVED
@click="$emit('click')"

LAYOUTS
-------

DAY:
(i) Title  Start-End
    Location
    Abstract

Start-End time should wrap to next line if not enough space

WEEK / MONTH:
(i) Title

QUEUE:
(i) Title

ITINERARY
(i) Start-End  Title
               Location
               
*/
import {itemTrackClasses, itemClasses, itemTitle} from '@/utils/Attributes';

export default {
    name: "CalendarItem",
    props: {
        item: {
            type: Object,
            required: true,
        },
        timezone: { // Not required, but strongly recommended!
            type: String,
            required: false,
        },
    },
    computed: {
        buildClasses() {
            return itemClasses(this.item)+" "+itemTrackClasses(this.item);
        },
        buildHref() {
            var basePath = '';
            if (window.location.pathname.startsWith('/admin')) {
                basePath = '/admin'
            }
            // item is either a meeting or appointment, so build appropriate path...
            // c.f. CalendarModalItem.vue 282-286
            if (isAppointment(this.item)) {
                return `${basePath}/appointments/${this.item.id}`; //   ${this.basePath}/appointments/${this.item.id}
            } else {
                return `${basePath}/book/show?id=${this.item.id}`;
            }
        },
    },
    methods: {
        itemTitle,
    },
}
</script>

<style>
a.calendar-item {
    color: #333;
    text-decoration: none;
}
a.calendar-item:active,
a.calendar-item:hover {
    color: #333;
    text-decoration: none;
}
.calendar-item {
    display: flex;
    cursor: pointer;
    position: relative;
    align-items: flex-start;
}
.calendar-item:hover {
    background-color: #eee;
}
.calendar-schedule-status {
    align-self: start;
}
.calendar-schedule-time {
    margin-right: 20px;
    min-width: 85px;
}
.calendar-schedule-detail {
    flex-grow: 1;
}

.calendar-item-location:before {
    content: none;
}
.calendar-item-location {
    text-overflow: ellipsis;
}
.calendar-schedule-cancelled {
    color: #999;
}
.calendar-item-extended {
    font-size: 12px;
    line-height: 16px;
    white-space: normal;
}
.calendar-item-abstract {
    margin-top: 2px;
    padding-top: 5px;
    border-top: 1px solid #3333;
}
.calendar-stackable {
    display: inline-block;
    margin-right: 5px;
}
*/
.calendar-item .calendar-icon {
    min-width: 16px; /* Stop icons being crushed by content */
}

/* https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-wrap */
/* overflow-wrap Vs word-break */
.calendar-item-location {
    word-break: break-all;
}
.calendar-item-location svg {
    height: 12px;
    width: 12px;
}

</style>